module.exports = __webpack_public_path__ + "img/Prodromos64_ua.ce747d01.webp";